import React, { FC, ReactElement } from 'react';
import './Region.scss';
import { Region as IRegion } from './Interfaces/Region';
import { Anchorlink, Heading } from 'mvw-component-library';
import { DESTINATION_REACT_APP_BASE_URL } from '../../Utility/constants';
interface IProps {
  RegionContent?: IRegion[] | [] | undefined;
}
const Region: FC<IProps> = ({ RegionContent }: IProps): ReactElement => {
  const regionTitle = 'BROWSE BY REGION';
  return (
    <div className="region-container" aria-label={regionTitle}>
      {/* <div role="heading" aria-level={1}> */}
      <Heading ariaLavel={2} headerTag="h2" headerLabel={regionTitle} classNames="nav-header-class" />
      {/* </div> */}
      <ul className="region-row">
        {RegionContent?.map((region) => {
          let link = `${DESTINATION_REACT_APP_BASE_URL}${region.regionId}`;
          return (
            <li key={region.regionId} className="region-col">
              <Anchorlink label={region.regionName} linkUrl={link} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Region;
